export default __webpack_public_path__ + "static/media/anniversary.926ca512.png";